import axios from "axios"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { updateAllTexture } from "../Actions/texture";

const useGetData = (pageNumber,obj_id) => {
    const [loading,setLoading] = useState(true);
    const [error,setError] = useState(false);
    const [data,setData] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        setLoading(true);
        setError(false);
        let cancel;
        if(obj_id) {
            axios({
                method:"GET",
                url:"https://api.ariisco.com/object/getNewGroupOfTexture/",
                params:{object_id:obj_id},
                cancelToken: new axios.CancelToken(c => cancel = c)
            }).then((res) => {
                dispatch(updateAllTexture(res.data))
                setData(res.data);
                setLoading(false);
            }).catch((err) => {
                if (axios.isCancel(err)) return
                setError(true);
            })
            return () => cancel()
        }
    },[obj_id, pageNumber])
  return {loading,error,data}
}


export default useGetData;